<template>
  <PageLayout v-if="show.layout"/>
  <router-view v-if="!show.layout"></router-view>
</template>
<script>

import PageLayout from './components/PageLayout.vue'

export default {
  name: 'App',
  // eslint-disable-next-line vue/require-prop-types
  components: {
    PageLayout
  },
  data: () => ({
    show: {
      layout: window.location.pathname.indexOf('login') !== 1,
    }
  }),
  beforeCreate() {
    document.querySelector('body').setAttribute('class', 'h-full overflow-hidden ')
    document.querySelector('html').setAttribute('class', 'h-full')
    document.getElementById('app').setAttribute('class', 'inline')
  },
  watch: {
    $route: function () {
      // Control the Nav when the route changes
      this.show.layout = window.location.pathname.indexOf('login') !== 1
    }
  }
}

</script>
